import { Typography } from '@nutrien/ddc-components';
import { useCorrelateLogging } from '@nutrien/ddc-fe-logging-react-router-dom';
import { useEffect } from 'react';

import Navigation from './Navigation/Navigation';

const Two = () => {
  const { info } = useCorrelateLogging();
  useEffect(() => info('Two:mount'), [info]);

  return (
    <>
      <Typography variant="headline1">PWA Two</Typography>
      <Navigation />
    </>
  );
};

export default Two;
